import { DatePipe } from '@angular/common';
import { Component, OnInit, inject, DestroyRef, ViewChild, ChangeDetectorRef, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { translate } from '@jsverse/transloco';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { SchedulerService } from 'src/app/services/api/scheduler.service';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import cronstrue from 'cronstrue';
import { RouterSegments } from 'src/app/models/router-segments';
import {AuthService} from 'src/app/services/auth/auth.service';
import { ColumnFilterComponent } from '../../instances-mgmt/column-filter/column-filter.component';
import moment from 'moment';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { Permissions, Datazone, Attributes } from 'src/app/models/principal/permission';
import { TenantService } from 'src/app/services/api/tenant.service';
import { CloudProvider } from 'src/app/models/cloud-provider/cloud-provider';
import { EnvironmentTableComponent } from '../environment-table/environment-table.component';
import { RunbookService } from 'src/app/services/api/runbook.service';
import { EditRunbookService } from 'src/app/services/api/edit-runbook.service';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { EnvironmentPaginatorComponent } from '../environment-paginator/environment-paginator.component';
import { InstancesService } from 'src/app/services/api/instances.service';


const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.RUNBOOK_READ_NONPII,
    action: Permissions. RUNBOOK_READ,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.RUNBOOK_CREATE_NONPII,
    action: Permissions.RUNBOOK_CREATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.RUNBOOK_READ_PII,
    action: Permissions. RUNBOOK_READ,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.RUNBOOK_CREATE_PII,
    action: Permissions.RUNBOOK_CREATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.RUNBOOK_READ_LIVE,
    action: Permissions. RUNBOOK_READ,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.RUNBOOK_CREATE_LIVE,
    action: Permissions.RUNBOOK_CREATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  }
];

@Component({
  selector: 'app-environment-runbook',
  templateUrl: './environment-runbook.html',
  styleUrl: './environment-runbook.scss',
  standalone: false
})
export class EnvironmentRunbook  implements OnInit {
private destroyRef = inject(DestroyRef);
@ViewChild(EnvironmentPaginatorComponent) paginatorRef: EnvironmentPaginatorComponent;
@ViewChild(EnvironmentTableComponent) tableRef: EnvironmentTableComponent;

  @Input() instance: any;
  readonly INSTANCE_DEPLOYING_STATES = [DeployStatus.INITIALIZED, DeployStatus.INITIALIZING, DeployStatus.INITIALIZE_FAILED,
    DeployStatus.DEPLOYING, DeployStatus.TERMINATED, DeployStatus.TERMINATION_FAILED, DeployStatus.TERMINATING,
    DeployStatus.CONFIGURING, DeployStatus.UPDATING, DeployStatus.TESTING, DeployStatus.FAILED,
    DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING,
    DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_APPLYING,
    DeployStatus.OPERATION_INPROGRESS, DeployStatus.TENANT_AGENT_CREATION_IN_PROGRESS, DeployStatus.START_FAILED, DeployStatus.STOP_FAILED, DeployStatus.STARTING,
    DeployStatus.STOPPING, DeployStatus.STOPPED, DeployStatus.STARTING_AGENT, DeployStatus.STOPPING_AGENT, DeployStatus.INPROGRESS];
  tenantId: string;
  runbookLoading = true;
  runbookLength = 0;
  displayColumns = [
    {
      key: 'name',
      name: 'RUNBOOK.RUNBOOK',
      type: 'text',
      sortable: true,
      visible: true,
      disable: true,
      keyLink: 'popup'
    },
    {
      key: 'componentVersion',
      name: 'RUNBOOK.VERSION',
      type: 'text',
      visible: true,
      disable: false,
      sortable: true
    },
    {
      key: 'updatedAt',
      name:  'RUNBOOK.MODIFIED_ON',
      type: 'date',
      visible: false,
      disable: false,
      sortable: true
    },
    {
      key: 'createdAt',
      name:  'RUNBOOK.CREATED_DATE',
      type: 'date',
      visible: true,
      disable: false,
      sortable: true
    },
    {
      key: 'createdBy',
      name: 'RUNBOOK.CREATED_BY',
      type: 'userIcon',
      visible: true,
      disable: false,
      sortable: false
    },
    {
      key: 'updatedBy',
      name: 'RUNBOOK.MODIFIED_BY',
      type: 'userIcon',
      visible: false,
      disable: false,
      sortable: false
    },
    {
      key: 'status',
      name:  'RUNBOOK.STATUS',
      type: 'status',
      visible: true,
      disable: true,
      sortable: true
    },
    {
      key: 'runbook',
      name: '',
      type: 'button',
      sortable: false,
      visible: true,
      disable: true
    },
    {
      key: 'action',
      name: 'RUNBOOK.ACTION',
      type: 'action',
      sortable: false,
      visible: true,
      disable: true
    },
    {
      key: 'runbookSettings',
      name: '',
      type: 'settings',
      visible: true,
      disable: true
    }
  ];

  showLoader = true;
  runbook: any;
  data:any;
  searchTerm: string = '';
  showCreateNew: boolean;
  selectedData: any;
  editEnable: boolean;
  pageName = 'runbook';
  scheduleStatus: any;
  status: any;
  isAWS: boolean;
  searchedResult = [];
  isRefreshing = false;

  dropdownsList: any;
  runbookStatus: any;
  runbookType: any;
  filteredColumns: any;
  clearData: boolean;
  filterStartDate: any;
  filterEndDate: any;
  selectedStatus = [];
  selectedType = [];
  selectedVersion = [];
  date:any;
  runbookVersion: any;
  instanceId: any;
  disableCreate = true;
  isFiltered = false;
  runbookResponse:boolean;
  apiNotFound = false;
  pageIndex = 0;
  paginationSize = 10;
  deployStatus = false;
  PermissionKeys = PermissionKeys;
  permissionsMap: { [key: string]: boolean; };
  showRunbook: boolean;
  isCreateAllowed:boolean;
  isDataLoaded:boolean;
  runbookStatusValue:any;

  constructor(private activatedRoute: ActivatedRoute, private router: Router, public authService:AuthService,
    public schedulerService: SchedulerService, public sidenavService: SidenavService,
    private toastrService: CustomToastrService, private permissionsService: PermissionsService, public datePipe: DatePipe, public instanceService: InstancesService,
    private dialog: MatDialog, public tenantService: TenantService, private cdr: ChangeDetectorRef, private runbookService: RunbookService, private EditRunbookService: EditRunbookService ) {

  }


  ngOnInit(): void {
    this.loadPermissionsAndDataZone();
    this.getInstanceDetails();
    if (!this.INSTANCE_DEPLOYING_STATES.includes(this.instance?.status)) {
      this.disableCreate = false;
    }
    
    this.tenantService.tenantData$.subscribe((data: any) => {
      this.isAWS = data === CloudProvider.AWS ? true : false;
    });
    this.tenantId = this.activatedRoute.snapshot.params.id;
    this.instanceId = this.activatedRoute.snapshot.params.instanceId;
     if (localStorage.getItem('filteredRunbookType')) {
      const userData = JSON.parse(localStorage.getItem('filteredRunbookType'));
      if (userData) {
        this.selectedType = userData;
        this.runbookType = this.selectedType;
        this.dropdownsList?.[0]?.options?.forEach(element => {
          if(this.selectedType.find(item=> item === element.value)) {
            element.selected = true;
          }
        });
      }
    }
    if (localStorage.getItem('filteredRunbookStatus')) {
      const userData = JSON.parse(localStorage.getItem('filteredRunbookStatus'));
      if (userData) {
        this.selectedStatus = userData;
        this.runbookStatus = this.selectedStatus;
        this.dropdownsList?.[1]?.options?.forEach(element => {
          if(this.selectedStatus.find(item=> item === element.value)) {
            element.selected = true;
          }
        });
      }
    }
    if (localStorage.getItem('filteredRunbookVersion')) {
      const userData = JSON.parse(localStorage.getItem('filteredRunbookVersion'));
      if (userData) {
        this.selectedVersion = userData;
        this.runbookVersion = this.selectedVersion;
        this.dropdownsList?.[2]?.options?.forEach(element => {
          if(this.selectedVersion.find(item=> item === element.value)) {
            element.selected = true;
          }
        });
      }
    }
    if (localStorage.getItem('filteredCustomDate')) {
      const dateData = JSON.parse(localStorage.getItem('filteredCustomDate'));
      if (dateData) {
        this.date = dateData;
        this.dropdownsList?.[1]?.options?.forEach(element => {
          if(dateData.find(item=> item === element.value)) {
            element.selected = true;
          }
        });
      }
    }
    this.fetchRunbook();
    this.resetRunbookFilter();
  }

    onPageChange(event) {
    this.paginationSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.tableRef?.pageChanged(event);
  }

   onTablePageChanged(event) {
    this.pageIndex = event.pageIndex;
    this.paginationSize = event.pageSize;
  }

  fetchRunbook(): void {
    this.showLoader = true;
    this.runbookLoading = true;
this.runbookService.getRunbook(this.instanceId)
.pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(response => {
        response = response?.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
        this.runbookLoading = false;
        this.runbook = response;
        this.data = this.runbook;
        this.displayColumns = this.isCreateAllowed && this.data?.some(row => row?.status === 'failed' || row?.status === 'config_failed') ? this.displayColumns : this.displayColumns.filter(item => item.key !== 'runbook');
        this.showLoader = false;
        this.runbook.length > 0 ? this.runbookResponse=true: this.runbookResponse = false;
        this.deployStatus = this.runbook.some(item => item.status === 'deploying' || item.status === 'configuring');
        this.initializeFilterItems();
      },
       (error) => {
        this.showLoader = false;
        if (error.httpStatusCode === 404){
          this.apiNotFound = true;
        } else {
        this.initializeFilterItems();
        setTimeout(() => {
          const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      }
      });
  }

  initializeFilterItems(){
  this.runbookVersion = Array.from(
      new Set(this.data?.map((item) => item.componentVersion || '-'))).filter((version) => version && version !== '-').map((version) => ({
        value: version,
        label: version,
        selected: false,
      }));

      this.runbookStatus = [
      {value: 'deploying', label: "Deploying",selected: false},
      {value: 'deployed', label: "Deployed",selected: false},
      {value: 'failed', label: "Failed",selected: false},
      {value: 'configuring', label: "Configuring",selected: false},
      {value: 'configured', label: "Configured",selected: false},
      {value: 'config_failed', label: "Config Failed",selected: false},
      {value: 'deleting', label: "Deleting",selected: false},
      {value: 'deleted', label: "Deleted",selected: false},
      {value: 'delete_failed', label: "Delete Failed",selected: false},
      {value: 'updating', label: "Updating",selected: false},
      {value: 'updated', label: "Updated",selected: false},
      {value: 'update_failed', label: "Update Failed",selected: false}
    ];
    this.runbookStatusValue = this.runbookStatus;

    this.runbookType = [
      {value: "Data Screening", label: "Data Screening", selected: false},
      {value: "COB", label: "COB", selected: false},
    ];

     const date = [
      {value: 'Modified Date', selected: false}
    ];

    this.dropdownsList = [
      {
        title: 'Type',
        placeholder: 'Select Type',
        options: this.runbookType
      },
      {
        title: 'Status',
        placeholder: 'Select Status',
        options: this.runbookStatus
      },
      {
        title: 'Version',
        placeholder: 'Select Version',
        options: this.runbookVersion
      },
      {
        title: 'Date',
        placeholder: 'Select Date',
        options: date
      }
    ];
}

/* Filters the table data based on the currently selected filter criteria */
  filterColumns(): void {
    if(this.runbookType) {
      this.dropdownsList[0].options.filter((item) => {
        if (this.runbookType?.find(type => type === item.value)) {
          item.selected = true;
        }
      });
    }
    if(this.runbookStatus) {
      this.dropdownsList[1].options.filter((item) => {
        if (this.runbookStatus?.find(status => status === item.value)) {
          item.selected = true;
        }
      });
    }
    if(this.runbookVersion) {
      this.dropdownsList[2].options.filter((item) => {
        if (this.runbookVersion?.find(version => version === item.value)) {
          item.selected = true;
        }
      });
    }
     if(this.date) {
      this.dropdownsList[3].options.filter((item) => {
        if (item.value === this.date) {
          item.selected = true;
        }
      });
    }
    const data = {
      name: translate('RUNBOOK.RUNBOOK'),
      title: translate('INSTANCE_STATUS.FILTER_TITLE'),
      subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
      filteredColumns: this.dropdownsList,
      dateCreated: this.instance?.dateCreated,
      runbookTypeList: this.dropdownsList?.[0].options,
      runbookStatusList: this.dropdownsList?.[1].options,
      runbookVersionList: this.dropdownsList?.[2].options,
      modifiedDate: this.dropdownsList?.[3].options,
      runbookStartDateChange: this.dropdownsList?.[3].options?.[0]?.selected ? moment(this.filterStartDate) : '',
      runbookEndDateChange: this.dropdownsList?.[3].options?.[0]?.selected ? moment(this.filterEndDate) : '',
      runbookColumns: [
        'status',
        'version',
        'date'
      ]
    };
    this.sidenavService.openInRightSidenav(ColumnFilterComponent, data)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(filteredColumns => {
      this.filteredColumns = filteredColumns;
      if (filteredColumns) {
        this.isFiltered = true;
        this.clearData = true;
        if(filteredColumns[0] !== '') {
          this.runbookType = filteredColumns[0];
        }
        if(filteredColumns[1] !== '') {
          this.runbookStatus = filteredColumns[1];
        }
        if(filteredColumns[2] !== '') {
          this.runbookVersion = filteredColumns[2];
        }
        if(filteredColumns[3] !== '') {
          localStorage.removeItem('filteredRunbookDate');
          this.date = filteredColumns[3];
          localStorage.setItem('filteredRunbookDate', JSON.stringify(filteredColumns[3]));
        }
         if (filteredColumns[0]?.length === 0 && filteredColumns[1]?.length === 0 && filteredColumns[2]?.length === 0 && filteredColumns[3]?.length === 0){
          this.resetRunbookFilter();
        } else {
          this.filterRunbookItems(filteredColumns);
        }
      }
    });
  }

  /* Filters the Runbook table data based on the selected filter criteria. */
  filterRunbookItems(filteredColumns): void {
    if (filteredColumns) {
      this.data = this.runbook;
      this.selectedStatus = [];
      this.selectedType = [];
      this.selectedVersion = [];
      if (filteredColumns[0]?.length > 0) {
        this.selectedType = filteredColumns[0];
        if (filteredColumns[0].length > 0) {
          localStorage.setItem('filteredRunbookType', JSON.stringify(this.selectedType));
          this.data = this.data?.filter(item => this.selectedType?.includes(item?.type));
        } else {
          localStorage.removeItem('filteredRunbookType');
        }
      }
      if (filteredColumns[1]?.length > 0) {
        this.selectedStatus = filteredColumns[1];
        if (filteredColumns[1].length > 0) {
          localStorage.setItem('filteredRunbookStatus', JSON.stringify(this.selectedStatus));
          this.data = this.data?.filter(item => this.selectedStatus?.includes(item?.status));
        } else {
          localStorage.removeItem('filteredRunbookStatus');
        }
      }
      if (filteredColumns[2]?.length > 0) {
        this.selectedVersion = filteredColumns[2];
        if (filteredColumns[2].length > 0) {
          localStorage.setItem('filteredRunbookVersion', JSON.stringify(this.selectedVersion));
          this.data = this.data?.filter(item => this.selectedVersion?.includes(item?.componentVersion));
        } else {
          localStorage.removeItem('filteredRunbookVersion');
        }
      }
      if (this.dropdownsList[3].options[0].selected && moment(filteredColumns[3][1].filteredStartDate).isValid() && moment(filteredColumns[3][1].filteredEndDate).isValid()) {
        this.filterStartDate = filteredColumns[3][1].filteredStartDate;
        this.filterEndDate = filteredColumns[3][1].filteredEndDate;
        localStorage.setItem('filteredRunbookStartDate', this.filterStartDate);
        localStorage.setItem('filteredRunbookEndDate', this.filterEndDate);

        const startDateUTC = moment.utc(moment(this.filterStartDate).format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day');
        const endDateUTC = moment.utc(moment(this.filterEndDate).format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day');
        this.data = this.data?.filter(item => {
          const itemDateUTC = moment.utc(item.updatedAt).startOf('day');
          return itemDateUTC.isSameOrAfter(startDateUTC) && itemDateUTC.isSameOrBefore(endDateUTC);
        });

      } else {
        this.filterStartDate = undefined;
        this.filterEndDate = undefined;
        localStorage.removeItem('filteredRunbookStartDate');
        localStorage.removeItem('filteredRunbookEndDate');
      }
    }
  }

  /* Returns a label for the Type */
   getTypeLabel(type): void {
    // return this.selectedType?.find(item=> item.value === type).label;
    return this.selectedType?.find(item => item.value === type)?.label || type || '';

  }

  /* Returns a label for the Status */
  getStatusLabel(status): void {
    const data = this.selectedStatus?.find(item => item.value === status)?.value || status || '';
    return this.runbookStatusValue.find(item => item.value === data)?.label;

  }

  /* Returns a label for the Version */
  getVersionLabel(version): void {
    // return this.runbookVersion?.find(item=> item.value === version).label;
            return this.selectedVersion?.find(item => item.value === version)?.label || version || '';

  }

  /* Converts the given date into a UTC timestamp. */
  getUTCTimestamp(date): any {
    return Date.parse(moment(new Date(date)).utc().format('DD MMM YYYY HH:mm:ss'));
  }

   /* Cleares the selected Status filter */
  cancelTypeFilter(data) {
    let selectedItem = this.selectedType.indexOf(data);
    if (selectedItem > -1) {
      localStorage.removeItem('filteredRunbookType');
      this.selectedType.splice(selectedItem, 1);
      this.dropdownsList[0].options.find(item => item.value === data).selected = false;
      localStorage.setItem('filteredRunbookType', JSON.stringify(this.selectedType));
      this.filterRunbookItems(this.filteredColumns);
    }
  }

  /* Cleares the selected Status filter */
  cancelStatusFilter(data) {
    let selectedItem = this.selectedStatus.indexOf(data);
    if (selectedItem > -1) {
      localStorage.removeItem('filteredRunbookStatus');
      this.selectedStatus.splice(selectedItem, 1);
      this.dropdownsList[1].options.find(item => item.value === data).selected = false;
      localStorage.setItem('filteredRunbookStatus', JSON.stringify(this.selectedStatus));
      this.filterRunbookItems(this.filteredColumns);
    }
  }

    /* Cleares the selected Version filter */
  cancelVersionFilter(data) {
    let selectedItem = this.selectedVersion.indexOf(data);
    if (selectedItem > -1) {
      localStorage.removeItem('filteredRunbookVersion');
      this.selectedVersion.splice(selectedItem, 1);
      this.dropdownsList[2].options.find(item => item.value === data).selected = false;
      localStorage.setItem('filteredRunbookVersion', JSON.stringify(this.selectedVersion));
      this.filterRunbookItems(this.filteredColumns);
    }
  }

   /* Cleares the selected Date filter */
  canceRunbookDateFilter() {
    this.filterStartDate = undefined;
    this.filterEndDate = undefined;
    this.dropdownsList?.[3]?.options?.filter((item) => {item.selected = false});
    this.date?.forEach(element => {
      if(element.includes(this.dropdownsList[3].options[0].value)) {
        this.date.pop(element);
      }
    });

    localStorage.removeItem('filteredRunbookStartDate');
    localStorage.removeItem('filteredRunbookEndDate');
    localStorage.removeItem('filteredCustomDate');
    localStorage.removeItem('filteredRunbookDate');
    this.filterRunbookItems(this.filteredColumns);
  }

  /* Reset the selected runbook filter */
  resetRunbookFilter(): void {
    this.isFiltered = false;
    this.selectedStatus = [];
    this.selectedType = [];
    this.selectedVersion = [];
    this.sidenavService.searchFilter.next('data');
    this.dropdownsList?.[0]?.options?.filter((item) => {item.selected = false});
    this.dropdownsList?.[1]?.options.filter((item) => {item.selected = false});
    this.dropdownsList?.[2]?.options?.filter((item) => {item.selected = false});
    this.dropdownsList?.[3]?.options?.filter((item) => {item.selected = false});
    this.status = undefined;
    this.runbookStatus = undefined;
    this.runbookType = undefined;
    this.date = undefined;
    this.runbookVersion = undefined;
    this.filterStartDate = undefined;
    this.filterEndDate = undefined;
    this.data = this.runbook;
    localStorage.removeItem('filteredRunbookType');
    localStorage.removeItem('filteredRunbookStatus');
    localStorage.removeItem('filteredRunbookVersion');
    localStorage.removeItem('filteredRunbookDate');
    localStorage.removeItem('filteredRunbookStartDate');
    localStorage.removeItem('filteredRunbookEndDate');
  }

  refreshClick(): void {
    this.isRefreshing = true;
    this.runbookLoading = true;
  if (this.isFiltered) {
    setTimeout(() => {
      this.isRefreshing = false;
      this.runbookLoading = false;
    }, 1000);
    return;
  }

  if (this.paginatorRef) {
    this.paginatorRef.pageIndex = 0;
  }

  this.fetchRunbook();
  this.getInstanceDetails();

  setTimeout(() => {
    this.isRefreshing = false;
    this.runbookLoading = false;
  }, 1000);
  }

  search(searchTerm?: string): void {
    this.searchTerm = searchTerm;
  }

  searchedItems(result): void {
    this.searchedResult = result;
    this.cdr.detectChanges();
  }

   resetPaginator() {
    this.pageIndex = 0;
     this.paginatorRef.pageIndex = 0;
  }

  createClick(): void {
     this.EditRunbookService.setData("");
      this.EditRunbookService.setIsEdit(false);
      this.EditRunbookService.setInstance(this.instance);
    const tenantId = this.activatedRoute.snapshot.params.id;
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT , tenantId, RouterSegments.BLUEPRINTS, this.activatedRoute.snapshot.params.blueprintId,
      RouterSegments.ENVIRONMENT, this.activatedRoute.snapshot.params.instanceId, RouterSegments.CREATE_RUNBOOK]);
  }

  redeployClick(data): void {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('RUNBOOK.REDEPLOY'),
        message: translate('RUNBOOK.REDEPLOY_MESSAGE'),
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          const obj = {
            id: this.activatedRoute.snapshot.params.instanceId,
            runbookId: data?.id
          }
          this.runbookService.putRunbook(obj).pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(response => {
            this.runbook.find(item => item.name === response?.name).status = response.status;
            this.deployStatus = this.runbook.some(item => item.status === 'deploying' || item.status === 'configuring');
            const tenantId = this.activatedRoute.snapshot.params.id;
            this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT , tenantId, RouterSegments.BLUEPRINTS, this.activatedRoute.snapshot.params.blueprintId,
              RouterSegments.ENVIRONMENT, this.activatedRoute.snapshot.params.instanceId], {state: {data: 'RUNBOOK'}});
            setTimeout(() => {
              const title = translate('RUNBOOK.REDEPLOY');
              const message = translate('RUNBOOK.REDEPLOY_TRIGGERED');
              this.toastrService.successMessage(message, title);
            }, 500);
          },
          (error) => {
            const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
            this.dialog.open(ErrorDialogComponent, {
              minHeight: '280px',
              width: '630px',
              panelClass: 'flex-dialog',
              data: {
                title:  translate('RUNBOOK.REDEPLOY_FAILED'),
                description: errorMessage
              }
            });
          });
        }
      })
  }

private async loadPermissionsAndDataZone() {
    this.runbookLoading = true;
    const dataZone = await this.initDataZone();
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    this.showRunbook =  (this.permissionsMap[PermissionKeys.RUNBOOK_READ_NONPII] && dataZone === Datazone.NONPII) || (this.permissionsMap[PermissionKeys.RUNBOOK_READ_PII] && dataZone === Datazone.PII) || (this.permissionsMap[PermissionKeys.RUNBOOK_READ_LIVE] && dataZone === Datazone.LIVE); 
    if(!this.showRunbook) this.runbookLoading = false;
    this.isCreateAllowed = (this.permissionsMap[PermissionKeys.RUNBOOK_CREATE_NONPII] && dataZone === Datazone.NONPII) || (this.permissionsMap[PermissionKeys.RUNBOOK_CREATE_PII] && dataZone === Datazone.PII) || (this.permissionsMap[PermissionKeys.RUNBOOK_CREATE_LIVE] && dataZone === Datazone.LIVE);
    this.isDataLoaded = true;  
  }

  private async waitForInstance() {
    let instance = this.instance;
    if (instance) return instance;
    while (!instance) {
      if (this.instance) {
        instance = this.instance;
        break;
      }
      const serviceInstance = this.EditRunbookService.getInstance();
      if (serviceInstance) {
        instance = serviceInstance;
        break;
      }
      await new Promise(resolve => setTimeout(resolve, 50));
    }
    return instance;
  }

  private async getDataZone() {
    const instance = this.instance ?? this.EditRunbookService.getInstance() ?? (await this.waitForInstance());
    return instance.dataZone;
  }

  private async initDataZone() {
    const dataZone = await this.getDataZone();
    return dataZone;
  }

  private getInstanceDetails(): void {
    const instanceId = this.activatedRoute.snapshot.params.instanceId;
    this.instanceService.getInstanceDetails(instanceId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          this.instance = data;
        }
      },
      (error) => {
        setTimeout(() => {
          const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

}
